import { initialStateValues } from 'redux/initialStateValues'
import { UPDATE_OUTLET_CODE, UPDATE_OUTLET_CAMERA_DETAILS } from './outletCodeTypes'

const initialState = {
    outletCode: initialStateValues.outletCode,
    outletCameraDetails: initialStateValues.outletCameraDetails
}

const outletReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_OUTLET_CODE:
            return {
                ...state,
                outletCode: action.payload,
            }
        case UPDATE_OUTLET_CAMERA_DETAILS:
            return {
                ...state,
                outletCameraDetails: action.payload
            }
        default: return state
    }
}

export default outletReducer